var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTransactionTimelineIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22.5,
    cy: 22.5,
    r: 22.5,
    fill: "#FFEFE6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.2122 22.5023V24.0856C31.2122 26.7089 27.3133 28.8356 22.5039 28.8356C17.7803 28.8356 13.9351 26.7842 13.7992 24.2256L13.7955 24.0856V22.5023C13.7955 25.1256 17.6944 27.2523 22.5039 27.2523C27.3133 27.2523 31.2122 25.1256 31.2122 22.5023ZM22.5039 16.1689C27.3133 16.1689 31.2122 18.2956 31.2122 20.9189C31.2122 23.5423 27.3133 25.6689 22.5039 25.6689C17.6944 25.6689 13.7955 23.5423 13.7955 20.9189C13.7955 18.2956 17.6944 16.1689 22.5039 16.1689Z",
    fill: "#FB8441"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransactionTimelineIcon);
export default __webpack_public_path__ + "static/media/transaction_timeline_icon.9da1fcc60a5f72720d4bd1bd13af3e4e.svg";
export { ForwardRef as ReactComponent };